{
  "slug": "can-anxiety-lower-iq-scores",
  "title": "هل يخفض القلق معدل الذكاء؟",
  "description": "يمكن للقلق أن يستهلك الانتباه أو الذاكرة العاملة، ولكن الآثار تختلف.",
  "category": "أسئلة اختبار الذكاء التي تم الرد عليها",
  "sections": [
    {
      "heading": "إجابة موجزة",
      "paragraphs": ["يمكن للقلق أن يستهلك الانتباه أو الذاكرة العاملة، ولكن الآثار تختلف."]
    },
    {
      "heading": "ما يؤثر عليها",
      "paragraphs": [
        "إن نوعية الاختبار، والعمر، والصحة، واللغة، والتعليم، والدوافع، والبيئة، والغرض كلها أمور مهمة.",
        "لا يمكن لتأثير متوسط الدراسة أن يتنبأ بشخص واحد بدقة."
      ]
    },
    {
      "heading": "التوجيه",
      "paragraphs": [
        "1- استخدام النوم الكافي، والظروف الهادئة، والمرافق، والأجهزة المناسبة.",
        "بالنسبة للأطفال، الصحة، الإعاقة، أو القرارات العالية المخاطر، استشارة مهني مؤهل."
      ]
    }
  ],
  "related": ["what-is-iq", "how-is-iq-measured", "can-iq-change-over-time"],
  "sources": [],
  "faqs": [],
  "summary": "يمكن للقلق أن يستهلك الانتباه أو الذاكرة العاملة، ولكن الآثار تختلف. 18 تموز/يوليه 2026."
}
